<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 13:10:46
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-30 19:55:21
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/cyjkts/component-cyjkts.vue
 * @Description: 描述
-->
<template>
  <div class="cyjkts">
    <div class="content">
      <div class="subtitle">
        <span class="title">健康指数</span>
        <div class="legends">
          <section class="legend" v-for="index in 3" :key="index"></section>
        </div>
      </div>
      <el-row class="icons">
        <el-col
          :span="4"
          class="icon"
          v-for="(item, index) in jkzs"
          :key="index"
          @click="setZblx(item.name)"
        >
          <i
            :style="{
              'background-image': `url(${folder(item)}/${item.name}@2x.png)`,
            }"
          />
          <span :class="{ active: item.name === zblx }">{{ item.name }}</span>
        </el-col>
      </el-row>
      <div class="subtitle">
        <span class="title">指数趋势</span>
      </div>
      <chart-line class="line-chart" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('production-management', ['loading', 'jkzs', 'zblx'])
  },
  methods: {
    ...mapActions('production-management', ['getJKZS']),
    ...mapMutations('production-management', ['setZblx']),
    folder ({ value }) {
      if (value === 0 || value === 1) {
        return '/image/production-management/icon/健康指数/预警'
      } else if (value === 2 || value === 3) {
        return '/image/production-management/icon/健康指数/中等'
      } else {
        return '/image/production-management/icon/健康指数/良好'
      }
    }
  },
  created () {
    this.getJKZS()
  }
}
</script>

<style lang="scss">
.cyjkts {
  padding-top: 52px;
  .content {
    padding: 10px 25px;
    height: 100%;
    position: relative;
    .subtitle {
      position: relative;
      .title {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.8;
        position: relative;
      }
      .legends {
        position: absolute;
        top: 5px;
        right: 0;
        .legend {
          display: inline-block;
          vertical-align: top;
          margin-left: 16px;
          &::before {
            content: "";
            width: 10px;
            height: 10px;
            display: inline-block;
          }
          &::after {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            display: inline-block;
            vertical-align: middle;
            margin-left: 6px;
          }
          &:nth-of-type(1) {
            &::before {
              background-color: #10f5b1;
            }
            &::after {
              content: "良好";
            }
          }
          &:nth-of-type(2) {
            &::before {
              background-color: #edc727;
            }
            &::after {
              content: "中等";
            }
          }
          &:nth-of-type(3) {
            &::before {
              background-color: #ec563e;
            }
            &::after {
              content: "预警";
            }
          }
        }
      }
    }
    .icons {
      margin-top: 15px;
      margin-bottom: 40px;
      height: 62px;
      .icon {
        position: relative;
        cursor: pointer;
        i {
          display: block;
          width: 62px;
          height: 62px;
          background-repeat: no-repeat;
          background-position: center center;
          position: relative;
        }
        span {
          display: block;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          position: absolute;
          width: 46px;
          height: 28px;
          left: calc((100% - 46px) / 2);
          line-height: 14px;
          text-align: center;
          bottom: -25px;
          &.active {
            color: #38f7ff;
          }
        }
      }
    }
    .line-chart {
      margin-top: 16px;
      height: 172px;
    }
  }
}
</style>
